import Aside from './asideNew';

export default Aside;
